<template lang="pug">
	a(class="linkServices" href="/admin/")
		.frame
		span.text Admin
</template>

<script>
export default {
	name: 'admin-button'
}
</script>



// WEBPACK FOOTER //
// src/common/components/admin-button.vue